import { ClipProvider } from "../../contexts/Clip/Provider";
import { ProgressProvider } from "../../contexts/Progress/Provider";
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { BackgroundBar } from "../SeekBar/BackgroundBar";

import { ProgressBar } from "../SeekBar/ProgressBar";

import styles from "./styles.module.css";

export const SoloSeekBar = () => {
  const { seekBar } = useVideoPlayerRefs();

  return (
    <div className={styles.container} ref={seekBar}>
      <BackgroundBar />
      <ClipProvider>
        <ProgressProvider>
          <ProgressBar />
        </ProgressProvider>
      </ClipProvider>
    </div>
  );
};
